// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZzgB","title":"Info_title__1cHLv","links":"Info_links__1dUwc","link":"Info_link__1Mpnt","logo":"Info_logo___7q-X"};